import { Component, Input, OnInit } from '@angular/core';
import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'ab-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  public title: any;
  public description: any;

  constructor() {}

  ngOnInit() {
    if (this.rendering.fields) {
      this.title = (this.rendering.fields.title as Field).value;
      this.description = (this.rendering.fields.description as Field).value;
    }
  }
}
